import { render, staticRenderFns } from "./DescuentosClientesPage.vue?vue&type=template&id=f70f0a90"
import script from "./DescuentosClientesPage.vue?vue&type=script&lang=js"
export * from "./DescuentosClientesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports